//router
import LayoutsRoute from './router/layouts-route';

//scss files
import './assets/css/bootstrap.min.css'
import './assets/css/typography.css'
import './assets/css/style.css';
import './assets/css/responsive.css'
import { useEffect } from 'react';
import {login} from "./actions/HomeActions"
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
// import  './assets/css/custom.css';

function App() {
  const login_details=localStorage.getItem("login_details")
  const dispatch=useDispatch()
  const history = useHistory()
  useEffect(()=>{
    if(login_details)
    dispatch(login(JSON.parse(login_details),history))
  },[])
  // useEffect(() => {
  //   const handleContextMenu = (e) => {
  //     e.preventDefault();
  //   };
  //   document.addEventListener('contextmenu', handleContextMenu);
  //   return () => {
  //     document.removeEventListener('contextmenu', handleContextMenu);
  //   };
  // }, []);

  return (
    <div className="App">
      <LayoutsRoute />
    </div>
  );
}

export default App;
